<div class="tracking-list"
     [mmTestId]="'ORDER_HISTORY.TRACKING_LIST'">
    <div class="tracking-list__items-wrapper">
        <div *ngFor="let trackingItem of (trackings | slice:0:visibleTrackingsLength); let last = last;"
             [mmTestTarget]="'order-line-delivery-tracking-id-value'">
            <ng-container *ngIf="trackingItem?.trackingNumber; else noTrackingTmpl">
                <a *ngIf="trackingItem?.trackingUrl; else simpleNumberTempl"
                   target="_blank"
                   (click)="navigateToDeliveryCarrierClicked(trackingItem?.trackingUrl)"
                   [href]="trackingItem?.trackingUrl">{{trackingItem?.trackingNumber}}</a>
            </ng-container>
            <ng-template #simpleNumberTempl>
                <span>{{trackingItem?.trackingNumber}}</span>
            </ng-template>
            <ng-container *ngIf="!last">,&nbsp;</ng-container>
        </div>
    </div>
    <ng-template #noTrackingTmpl>
        <span class="tracking-list__empty-state">
            {{'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SHIPPING_DETAILS.NOT_DEFINED' | translate}}
        </span>
    </ng-template>

    <div *ngIf="trackings?.length > toggleLength"
         (click)="toggleTrackingLength()"
         [mmTestTarget]="'order-line-delivery-tracking-toggler'"
         class="tracking-list__toggler">
        <ng-container *ngIf="shouldShowFullList; else lessTempl">
            <div>{{ 'SHARED.SHOW_LESS.LABEL' | translate }}</div>
            <div class="tracking-list__toggle-icon">
                <mm-icon type="fluid"
                         name="chevron-up"></mm-icon>
            </div>
        </ng-container>
    </div>
    <ng-template #lessTempl>
        <div>{{ 'SHARED.SHOW_MORE.LABEL' | translate }}</div>
        <div class="tracking-list__toggle-icon">
            <mm-icon type="fluid"
                     name="chevron-down"></mm-icon>
        </div>
    </ng-template>
</div>
